import script from "./MergeCollections.vue?vue&type=script&setup=true&lang=js"
export * from "./MergeCollections.vue?vue&type=script&setup=true&lang=js"

import "./MergeCollections.vue?vue&type=style&index=0&id=1afd1161&lang=scss&scoped=true"
script.__scopeId = "data-v-1afd1161"

export default script